export const headerMemberTable = [
  { header: 'Miembros', key: 'employee' },
  { header: 'Puesto', key: 'role' },
  { header: 'Seniority', key: 'seniority' },
  { header: 'Dedicacion', key: 'dedication' },
  { header: 'Ayudante', key: 'helper' },
  { header: 'Fecha', key: 'date' },
  { header: '', key: 'buttons' },
];
